/*
===============================================================================================================
                                 Copyright 2022-2025, Blue Yonder Group, Inc.
                                              All Rights Reserved

                                THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
                                            BLUE YONDER GROUP, INC.

                            The copyright notice above does not evidence any actual
                                 or intended publication of such source code.

===============================================================================================================
*/

/* eslint-disable no-console */
import apiClient from '@/utilities/api-client';
import { isEmpty } from '@/utilities/validation';
import { isNil } from 'lodash';
import compileChangeObject from './compile-signup-change-object';
import { errorHandler } from '../error-handling';

export default async ({
  changes: changeArray, token, rootOrgId,
  productName, getAdminFeature,
}) => {
  if (isEmpty(changeArray)) return;
  const body = {
    ...compileChangeObject(changeArray, productName),
  };

  const canSkipPrereg = getAdminFeature('signup')?.canSkipPrereg;
  try {
    if (canSkipPrereg && isNil(body.applicant.customersToUse)) {
      return;
    }
    await apiClient.post(`${rootOrgId}/prereg/create`,
      body,
      {
        headers: {
          'Content-Type': 'application/json',
          'cache-control': 'no-cache',
          Authorization: token,
        },
      });
  } catch (e) {
    console.log('Could not sign up the company');
    console.log(e);
    throw new Error(errorHandler.checkInvalidTradingName(e));
  }
};
